import { useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5511986765185?text=Preciso%20de%20um%20or%C3%A7amento.';
const FORM_URL = 'https://readdy.ai/api/form/d7glr6f1fip3ogo5fnig';

export default function ContatoFooter() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const formData = new FormData(form);
    const body = new URLSearchParams();
    formData.forEach((value, key) => body.append(key, value.toString()));
    try {
      await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      form.reset();
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 6000);
    } catch {
      // silently fail
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-stone-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* CTA Final */}
        <div className="bg-stone-900 rounded-2xl p-8 md:p-12 mb-12 flex flex-col lg:flex-row gap-8 items-center justify-between">
          <div className="text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Fale com um Consultor Thelux Agora
            </h2>
            <p className="text-white/60 text-sm">
              Atendimento personalizado para o seu projeto. Sem compromisso.
            </p>
          </div>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-7 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap shrink-0 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg"></i>
            </div>
            Falar no WhatsApp
          </a>
        </div>

        {/* Formulário + Contato */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-12">
          <div>
            <h3 className="text-xl font-bold text-stone-800 mb-2">Solicite seu Orçamento</h3>
            <p className="text-stone-500 text-sm mb-6">
              Preencha o formulário e um consultor técnico entrará em contato em até 24 horas.
            </p>

            {submitted ? (
              <div className="bg-green-50 border border-green-200 rounded-xl p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-green-100 text-green-600 mx-auto mb-3">
                  <i className="ri-checkbox-circle-line text-2xl"></i>
                </div>
                <p className="font-semibold text-green-800 text-sm">Mensagem enviada com sucesso!</p>
                <p className="text-green-600 text-sm mt-1">Em breve entraremos em contato.</p>
              </div>
            ) : (
              <form
                data-readdy-form
                id="orcamento-form"
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                <div>
                  <label className="block text-sm font-semibold text-stone-600 mb-1">Nome completo</label>
                  <input
                    type="text"
                    name="nome"
                    required
                    placeholder="Seu nome"
                    className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm text-stone-800 bg-white focus:outline-none focus:border-amber-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-stone-600 mb-1">E-mail</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="seu@email.com"
                    className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm text-stone-800 bg-white focus:outline-none focus:border-amber-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-stone-600 mb-1">WhatsApp</label>
                  <input
                    type="tel"
                    name="whatsapp"
                    required
                    placeholder="(11) 99999-9999"
                    className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm text-stone-800 bg-white focus:outline-none focus:border-amber-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-stone-600 mb-1">Serviço de interesse</label>
                  <select
                    name="servico"
                    required
                    className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm text-stone-800 bg-white focus:outline-none focus:border-amber-400 transition-colors cursor-pointer"
                  >
                    <option value="">Selecione...</option>
                    <option value="Fechamento de Sacada Articulada">Fechamento de Sacada Articulada</option>
                    <option value="Box para Banheiro">Box para Banheiro</option>
                    <option value="Espelhos e Painéis">Espelhos e Painéis</option>
                    <option value="Guarda-corpos e Corrimãos">Guarda-corpos e Corrimãos</option>
                    <option value="Fachada Comercial">Fachada Comercial</option>
                    <option value="Divisórias e Portas de Vidro">Divisórias e Portas de Vidro</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-stone-600 mb-1">Mensagem</label>
                  <textarea
                    name="mensagem"
                    rows={3}
                    maxLength={500}
                    placeholder="Descreva brevemente seu projeto..."
                    className="w-full border border-stone-200 rounded-lg px-4 py-2.5 text-sm text-stone-800 bg-white focus:outline-none focus:border-amber-400 transition-colors resize-none"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-amber-500 hover:bg-amber-600 disabled:opacity-60 text-white font-bold py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  {loading ? 'ENVIANDO...' : 'ENVIAR SOLICITAÇÃO DE ORÇAMENTO'}
                </button>
              </form>
            )}
          </div>

          <div className="flex flex-col gap-6">
            <div>
              <h3 className="text-xl font-bold text-stone-800 mb-4">Informações de Contato</h3>
              <ul className="space-y-4">
                {[
                  { icon: 'ri-whatsapp-line', label: 'WhatsApp', value: '(11) 98676-5185', href: WHATSAPP_URL },
                  { icon: 'ri-map-pin-line', label: 'Atendimento', value: 'São Paulo e Grande SP', href: '#' },
                  { icon: 'ri-time-line', label: 'Horário', value: 'Seg–Sex: 8h–18h | Sáb: 8h–13h', href: '#' },
                  { icon: 'ri-global-line', label: 'Site', value: 'vidrosthelux.com.br', href: 'https://vidrosthelux.com.br' },
                ].map((c) => (
                  <li key={c.label} className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-stone-200 text-stone-600 shrink-0">
                      <i className={`${c.icon} text-base`}></i>
                    </div>
                    <div>
                      <p className="text-xs text-stone-400 font-medium">{c.label}</p>
                      <a
                        href={c.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-stone-700 text-sm font-semibold hover:text-amber-600 transition-colors cursor-pointer"
                      >
                        {c.value}
                      </a>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-2xl overflow-hidden h-[180px]">
              <img
                src="https://readdy.ai/api/search-image?query=S%C3%A3o%20Paulo%20city%20skyline%20aerial%20view%20modern%20buildings%20luxury%20residential%20towers%20clear%20sky%20daytime&width=800&height=400&seq=sp001&orientation=landscape"
                alt="São Paulo"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Footer bottom */}
        <div className="border-t border-stone-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <img
            src="https://static.readdy.ai/image/b82e091d2ee2b446e9b53ab9857e20be/1bea56054998f72dc157944f3d260472.png"
            alt="Vidros Thelux"
            className="h-8 object-contain"
          />
          <p className="text-stone-400 text-xs text-center">
            © 2025 Vidros Thelux — vidrosthelux.com.br — Todos os direitos reservados.
          </p>
          <div className="flex gap-3">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-200 text-stone-500 hover:bg-stone-700 hover:text-white transition-all duration-200 cursor-pointer"
            >
              <i className="ri-instagram-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
